<script setup>
import { ref, watch } from 'vue'

const props = defineProps({
  isOpen: Boolean,
  selectedIds: {
    type: Array,
    default: () => []
  },
  statuses: {
    type: Array,
    default: () => []
  }
})

const emit = defineEmits(['close', 'confirm'])

const loading = ref(false)
const selectedStatus = ref('')

const closeForm = () => {
  if (loading.value) return
  emit('close')
}

const handleSubmit = () => {
  if (!selectedStatus.value) return
  emit('confirm', selectedStatus.value)
}

// Reset status khi mở modal
watch(() => props.isOpen, (newVal) => {
  if (newVal) {
    selectedStatus.value = ''
  }
})
</script>

<template>
  <div v-if="isOpen" class="form-sidebar-overlay" @click.self="closeForm">
    <div class="form-sidebar">
      <div class="d-flex justify-content-between align-items-center mb-4">
        <h5 class="mb-0 text-primary"><i class="fa fa-refresh me-2"></i>Change Status</h5>
        <button class="btn-close" :disabled="loading" @click="closeForm"></button>
      </div>

      <div class="alert alert-info py-2 mb-4">
        <div class="fw-bold mb-1"><i class="fa fa-info-circle me-1"></i> Đang chọn {{ selectedIds.length }} đơn hàng:</div>
        <div class="text-truncate" :title="selectedIds.join(', ')">
          <small>ID: {{ selectedIds.join(', ') }}</small>
        </div>
      </div>

      <form @submit.prevent="handleSubmit" class="d-flex flex-column h-100">
        <div class="mb-4">
          <label class="form-label fw-bold">Chọn trạng thái mới *</label>
          <select 
            v-model="selectedStatus" 
            class="form-select" 
            required
            :disabled="loading"
          >
            <option value="" disabled>-- Chọn trạng thái --</option>
            <option v-for="status in statuses" :key="status.id" :value="status.name">
              {{ status.display_name }}
            </option>
          </select>
          <div class="form-text mt-2 text-warning">
            <i class="fa fa-exclamation-triangle me-1"></i>
            Tất cả các đơn hàng đã chọn sẽ được chuyển sang trạng thái này.
          </div>
        </div>

        <div class="sidebar-footer d-flex gap-2 mt-auto">
          <button
            type="button"
            class="btn btn-outline-secondary w-100"
            :disabled="loading"
            @click="closeForm"
          >
            Hủy
          </button>
          <button
            type="submit"
            class="btn btn-primary w-100"
            :disabled="loading || !selectedStatus"
          >
            <span v-if="loading" class="spinner-border spinner-border-sm me-1"></span>
            Xác nhận đổi
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<style scoped>
.form-sidebar-overlay {
  position: fixed;
  top: 0; left: 0;
  width: 100%; height: 100%;
  background: rgba(0,0,0,0.4);
  z-index: 9999;
}

.form-sidebar {
  position: fixed;
  top: 0; right: 0;
  width: 400px; height: 100%;
  background: white;
  padding: 30px;
  box-shadow: -5px 0 25px rgba(0,0,0,0.15);
  display: flex;
  flex-direction: column;
  animation: slideIn 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94) both;
}

.sidebar-footer {
  margin-top: auto;
  padding-top: 20px;
}

@keyframes slideIn {
  from { transform: translateX(100%); }
  to { transform: translateX(0); }
}

.btn:disabled {
  cursor: not-allowed;
  opacity: 0.7;
}

.alert-info {
  background-color: #eef2ff;
  border-color: #e0e7ff;
  color: #3730a3;
}
</style>
